"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return [_react.default.createElement("path", {
    d: "m1.1152 20.418 10-19h1.7699l10 19-.8849 1.4657h-20l-.885-1.4657z",
    fill: "#FFA524"
  }), _react.default.createElement("path", {
    d: "M13.0034 14.1338h-2v-6h2v6zm-2.25 2.75c0-.6904.5597-1.25 1.25-1.25.6904 0 1.25.5596 1.25 1.25 0 .6903-.5596 1.25-1.25 1.25-.6903 0-1.25-.5597-1.25-1.25z"
  }), _react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m1.1152 20.418.885 1.4657h20l.8849-1.4657-10-19h-1.7699l-10 19zm10.885-16.3872 8.3436 15.8529H3.6565l8.3437-15.8529z"
  })];
};

exports.default = _default;